import PropTypes from 'prop-types';
import React from 'react';
import ChartSummaryCard from '../ChartSummaryCard';
import { SUMMARY_CARD } from '../SummaryCard';
export default function ColorSummaryCard(_ref) {
  var children = _ref.children,
      right = _ref.right;

  if (right) {
    return /*#__PURE__*/React.createElement(ChartSummaryCard, {
      right: right
    }, children);
  } // eslint-disable-next-line react/jsx-no-useless-fragment


  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
ColorSummaryCard.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/no-unused-prop-types
  ascend: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  descend: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  inverseColor: PropTypes.bool,
  right: PropTypes.node
};
ColorSummaryCard.defaultProps = {
  children: null,
  ascend: false,
  descend: false,
  inverseColor: false,
  right: null
};
ColorSummaryCard[SUMMARY_CARD] = {
  cardClassName: function cardClassName(_ref2) {
    var ascend = _ref2.ascend,
        descend = _ref2.descend,
        _ref2$inverseColor = _ref2.inverseColor,
        inverseColor = _ref2$inverseColor === void 0 ? false : _ref2$inverseColor,
        right = _ref2.right;
    var isDefault = !ascend && !descend;
    return {
      'jmtp-color-summary-card': true,
      'jmtp-color-summary-card-default': isDefault,
      'jmtp-color-summary-card-ascend': isDefault ? false : inverseColor ? !ascend : ascend,
      'jmtp-color-summary-card-descend': isDefault ? false : inverseColor ? !descend : descend,
      'jmtp-chart-summary-card': !!right
    };
  }
};